import { render, staticRenderFns } from "./ComponentFooter.vue?vue&type=template&id=003f9d66&"
import script from "./ComponentFooter.vue?vue&type=script&lang=js&"
export * from "./ComponentFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports